import { component } from "../util/dom";
import tooltip from "../components/tooltip";

component("tooltip", tooltip);
